"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["large", "medium", "white"];
var _templateObject;
var BFLogo = function BFLogo(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    style: {
      fill: "#f8e07e"
    },
    d: "M145.02 131.1v-13h-33.8v.02H98.74V277.8h14.15v-71.42h18.31V193.1h-18.31v-62h32.13z"
  }), _react.default.createElement("path", {
    d: "M157.82 123.57c12.55-3.42 20.74-15.51 20.74-35.36 0-26.46-15.74-41.51-42.43-41.51H98.74v65.91h14.15V59.93h23.26c18.94 0 28.06 8.9 28.06 28.28 0 14.16-4.75 23.33-14.34 27.33v17.22c12.91 3.8 21 14 21 30 0 21-10.27 30.34-31 30.34H136v13.26h3.76c28.29 0 45.4-15.06 45.4-43.55.04-21.45-10.43-35.36-27.34-39.24Z",
    style: {
      fill: "#cd5b49"
    }
  }));
};
BFLogo.defaultProps = {
  'data-name': "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 280 324.5"
};
var BFLogoWhite = function BFLogoWhite(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("defs", null, _react.default.createElement("style", null, ".cls-1", "{", "fill:#fff", "}")), _react.default.createElement("path", {
    className: "cls-1",
    d: "M145.02 131.1v-13h-33.8v.02H98.74V277.8h14.15v-71.42h18.31V193.1h-18.31v-62h32.13z"
  }), _react.default.createElement("path", {
    className: "cls-1",
    d: "M157.82 123.57c12.55-3.42 20.74-15.51 20.74-35.36 0-26.46-15.74-41.51-42.43-41.51H98.74v65.91h14.15V59.93h23.26c18.94 0 28.06 8.9 28.06 28.28 0 14.16-4.75 23.33-14.34 27.33v17.22c12.91 3.8 21 14 21 30 0 21-10.27 30.34-31 30.34H136v13.26h3.76c28.29 0 45.4-15.06 45.4-43.55.04-21.45-10.43-35.36-27.34-39.24Z"
  }));
};
BFLogoWhite.defaultProps = {
  id: "Layer_1",
  'data-name': "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 280 324.5"
};
var LogoStyles = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  svg {\n    height: ", ";\n  }\n"])), function (props) {
  if (props.large) return "110px";else if (props.medium) return "83px";
  return "55px";
});
var Logo = function Logo(_ref) {
  var large = _ref.large,
    medium = _ref.medium,
    white = _ref.white,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(LogoStyles, Object.assign({
    alt: "BestFit Logo",
    large: large,
    medium: medium
  }, props), white ? _react.default.createElement(BFLogoWhite, null) : _react.default.createElement(BFLogo, null));
};
var _default = Logo;
exports.default = _default;